import React, { ReactNode, useEffect, useState } from "react";
import { Line } from "react-chartjs-2";
import { NavLink } from "react-router-dom";
import Panel from "../Panel";
import { faker } from "@faker-js/faker";

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler,
  ScriptableContext,
} from "chart.js";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Filler,
  Legend
);

type BasicInfoCardProps = {
  panelTitle?: any;
  panelSubtitle?: any;
  title?: any;
  sufix?: any;
  labels?: any;
  data?: any;
  chartData?: any[];
  children?: ReactNode;
  className?: string;
  maxValue?: number;
  online?: 0 | 1;
};

const BasicInfoCard = (props: BasicInfoCardProps) => {
  const labels = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const [chartData, setChartData] = useState(
    props.chartData && props.chartData
  );

  useEffect(() => {
    setChartData(props.chartData && props.chartData);
  });

  const getColorStatus = (status) => {
    switch (status) {
      case 0: {
        return "rgb(220, 53, 69)";
      }
      case 1: {
        return "#3681c3";
      }
    }
  };

  const data = () => {
    return {
      labels: labels,
      datasets: [
        {
          fill: true,
          data: chartData,
          // data: labels.map(() => faker.datatype.number({ min: 0, max: 1000 })),
          backgroundColor: (context: ScriptableContext<"line">) => {
            const ctx = context.chart.ctx;
            const gradient = ctx.createLinearGradient(0, 0, 0, 200);
            gradient.addColorStop(0, "rgba(54,129,195,1)");
            gradient.addColorStop(0.1, "rgba(54,129,195,0.3)");
            gradient.addColorStop(0.3, "rgba(54,129,195,0)");
            return gradient;
          },
          borderColor: getColorStatus(props.online),
          lineTension: 0.4,
        },
      ],
    };
  };

  const offline_device = () => {
    return {
      labels: labels,
      datasets: [
        {
          fill: true,
          data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
          // data: labels.map(() => faker.datatype.number({ min: 0, max: 1000 })),
          backgroundColor: (context: ScriptableContext<"line">) => {
            const ctx = context.chart.ctx;
            const gradient = ctx.createLinearGradient(0, 0, 0, 200);
            gradient.addColorStop(0, "rgba(54,129,195,1)");
            gradient.addColorStop(0.1, "rgba(54,129,195,0.3)");
            gradient.addColorStop(0.3, "rgba(54,129,195,0)");
            return gradient;
          },
          borderColor: getColorStatus(props.online),
          lineTension: 0.4,
        },
      ],
    };
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        display: false,
        position: "top" as const,
      },
      title: {
        display: false,
      },
    },
    scales: {
      yAxis: {
        display: false, // Hide Y axis labels
        max: props.maxValue ? props.maxValue : 100,
        min: 0,
      },
      // y: {
      //   display: false, // Hide Y axis labels
      //   max: props.maxValue ? props.maxValue : 100,
      // },
      x: {
        display: false, // Hide X axis labels
      },
    },
    maintainAspectRatio: false,
    bezierCurve: true,
    layout: {
      padding: 0,
      margin: 0,
    },
    elements: {
      point: {
        radius: 0,
      },
    },
    pointDot: false,
  };

  return (
    <Panel
      title={props.panelTitle}
      subtitle={props.panelSubtitle}
      className={`panel-css ${props.className && props.className}`}
    >
      <div className="basic-info-card">
        <div className="text-info">
          <span className="title">{props.title}</span>
          <span className="sufix">{props.sufix}</span>
        </div>
        {props.chartData && (
          <div className="chart-info">
            <Line
              data={props.online == 1 ? data() : offline_device()}
              options={options}
              width={10}
              height={2}
            />
          </div>
        )}
        {props.children && props.children}
      </div>
    </Panel>
  );
};

export default BasicInfoCard;
